import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { LeftCircleOutlined, PrinterOutlined } from '@ant-design/icons';
import { AButton, ATitle, Loading } from '../../../../components';
import {
  IProfessional,
  ITreatment,
  ITreatmentLog,
} from '../../../../shared/interfaces';
import { useToast } from '../../../../hooks/toast';
import api from '../../../../services/api';
import { ContainerMenuPrint } from './styles';
import { TreatmentEvolutionReport } from '../../../../shared/reports/TreatmentEvolution';

const TreatmentEvolutionPrint: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addToast } = useToast();
  const [loading, setLoading] = useState<boolean>(true);
  const [treatment, setTreatment] = useState<ITreatment | null>(null);
  const [logs, setLogs] = useState<ITreatmentLog[]>([]);

  const loadData = useCallback(async () => {
    if (!id) return;

    setLoading(true);
    try {
      const [treatmentResponse, logsResponse, professionalsResponse] =
        await Promise.all([
          api.get(`/treatments/${id}`),
          api.get(`/treatments-logs/list/${id}`),
          api.get('/professionals/select'),
        ]);

      const professionals = professionalsResponse.data as IProfessional[];
      const logsWithSignerName = (logsResponse.data || []).map(
        (log: ITreatmentLog) => ({
          ...log,
          signed_professional_name:
            professionals.find((prof) => prof.id === log.professional_id)
              ?.name || null,
          signed_professional_signature:
            professionals.find((prof) => prof.id === log.professional_id)
              ?.signature || null,
        }),
      );

      setTreatment(treatmentResponse.data?.treatment || null);
      setLogs(logsWithSignerName);
    } catch (error: any) {
      addToast({
        type: 'error',
        title: 'Erro',
        description:
          error?.response?.data?.message ||
          'Nao foi possivel carregar a impressao da evolucao.',
      });
    } finally {
      setLoading(false);
    }
  }, [id, addToast]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  if (loading) return <Loading load />;

  return (
    <>
      <ATitle icon={<PrinterOutlined />}>
        Imprimir Evolucao do Tratamento
      </ATitle>
      <ContainerMenuPrint>
        <AButton
          type="default"
          onClick={() => navigate(-1)}
          icon={<LeftCircleOutlined />}
        >
          Voltar
        </AButton>
      </ContainerMenuPrint>

      <TreatmentEvolutionReport treatment={treatment} logs={logs} />
    </>
  );
};

export default TreatmentEvolutionPrint;
